(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumera-home"] && !Shopify.designMode) return;
  try {
    
  document.body.classList.add('lumera-home-active');

  const nav = document.querySelector('[data-lumera-nav]');
  const revealItems = document.querySelectorAll('[data-lumera-reveal]');
  const hero = document.querySelector('.lumera-hero');
  const heroVideo = document.querySelector('[data-lumera-hero-video]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (nav) {
    let previousScrollY = window.scrollY;
    let navFrame = 0;

    const updateNavDirection = () => {
      const currentScrollY = window.scrollY;
      const scrollingDown = currentScrollY > previousScrollY;
      const menuOpen = nav.querySelector('details[open]');

      nav.classList.toggle('is-hidden', scrollingDown && currentScrollY > 140 && !menuOpen);
      previousScrollY = currentScrollY;
      navFrame = 0;
    };

    window.addEventListener('scroll', () => {
      if (!navFrame) navFrame = window.requestAnimationFrame(updateNavDirection);
    }, { passive: true });
  }

  if (nav && hero) {
    const navObserver = new IntersectionObserver((entries) => {
      nav.classList.toggle('is-scrolled', !entries[0].isIntersecting);
    }, { threshold: 0.08 });

    navObserver.observe(hero);
  }

  if (reducedMotion) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    revealItems.forEach((item) => observer.observe(item));

    const saveData = navigator.connection && navigator.connection.saveData;

    if (hero && heroVideo && !saveData) {
      let targetTime = 0;
      let animationFrame = 0;
      let touchTracking = false;
      let touchStartX = 0;
      let touchStartY = 0;

      const animateVideo = () => {
        const difference = targetTime - heroVideo.currentTime;

        if (Math.abs(difference) > 0.012) {
          heroVideo.currentTime += difference * 0.2;
          animationFrame = requestAnimationFrame(animateVideo);
        } else {
          animationFrame = 0;
        }
      };

      const seekFromPointer = (clientX, clientY) => {
        if (!Number.isFinite(heroVideo.duration) || heroVideo.duration <= 0) return;

        const bounds = hero.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (clientX - bounds.left) / bounds.width));
        const verticalProgress = Math.min(1, Math.max(0, (clientY - bounds.top) / bounds.height));

        targetTime = progress * heroVideo.duration;
        hero.style.setProperty('--lumera-pointer-x', `${(progress - 0.5) * 10}px`);
        hero.style.setProperty('--lumera-pointer-y', `${(verticalProgress - 0.5) * 5}px`);

        if (!animationFrame) animationFrame = requestAnimationFrame(animateVideo);
      };

      const initialiseVideo = () => {
        targetTime = heroVideo.duration * 0.5;
        heroVideo.currentTime = targetTime;
        heroVideo.pause();
      };

      const revealVideo = () => {
        hero.classList.add('is-video-ready');
      };

      if (heroVideo.readyState >= 1) {
        initialiseVideo();
      } else {
        heroVideo.addEventListener('loadedmetadata', initialiseVideo, { once: true });
      }

      if (heroVideo.readyState >= 3) {
        revealVideo();
      } else {
        heroVideo.addEventListener('canplay', revealVideo, { once: true });
      }

      hero.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'mouse') {
          seekFromPointer(event.clientX, event.clientY);
          return;
        }

        if (!touchTracking) return;
        const deltaX = Math.abs(event.clientX - touchStartX);
        const deltaY = Math.abs(event.clientY - touchStartY);

        if (deltaX > deltaY && deltaX > 8) {
          event.preventDefault();
          seekFromPointer(event.clientX, event.clientY);
        }
      }, { passive: false });

      hero.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        touchTracking = true;
        touchStartX = event.clientX;
        touchStartY = event.clientY;
      }, { passive: true });

      const stopTouchTracking = () => {
        touchTracking = false;
      };

      hero.addEventListener('pointerup', stopTouchTracking, { passive: true });
      hero.addEventListener('pointercancel', stopTouchTracking, { passive: true });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
